import { formatNumber } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { get } from 'lodash';
import { AppConfigService } from '../../app-config.service';

@Pipe({
  name: 'percent',
  standalone: false
})
export class PercentPipe implements PipeTransform {
  constructor(private readonly _appConfigService: AppConfigService) {}

  transform(percent: number | string, decimal = 2): string {
    const langue = get(this._appConfigService, 'configData.contexteEnvironnement.langue', 'fr');

    let formattedPercent: string =
      typeof percent !== 'undefined' && percent !== null && this.hasNumbers(percent.toString())
        ? formatNumber(Number(percent), langue, `1.${decimal}-2`)
        : '---';

    if (langue === 'en') {
      formattedPercent = formattedPercent + '%';
    } else {
      formattedPercent = formattedPercent.replace(/\./g, ',') + ' %';
    }

    return formattedPercent;
  }

  private hasNumbers(input): boolean {
    return /\d/.test(input);
  }
}
